import {connect} from "react-redux";
import SmView from "./SmView";
import {bindActionCreators} from "redux";
import { smDetailsByUserId } from "../../../../service/Dealer/action";


const mapStateToProps = (state) => ({
    getSmDetails:state.Dealer.getSmDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            smDetailsByUserId
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(SmView);
